import { createSlice } from '@reduxjs/toolkit';
import { getReportsVisibility } from './actions';

export const INITIAL_STATE = {
  activeOrganizations: [],
  default: 'show'
};

const slice = createSlice({
  name: 'reports',
  initialState: INITIAL_STATE,
  extraReducers: builder => {
    builder
      .addCase(getReportsVisibility.pending, state => {
        state.activeOrganizations = [];
        state.default = 'show';

        return state;
      })

      .addCase(getReportsVisibility.fulfilled, (state, { payload }) => {
        state.activeOrganizations = payload.organizations;
        state.default = payload.default;

        return state;
      })

      .addCase(getReportsVisibility.rejected, state => {
        state.activeOrganizations = [];
        state.default = 'show';

        return state;
      });
  }
});

export default slice.reducer;
